<template>
    <div class="row">
        <div class="col-12 text-center mt-3">
            <h2 class="segment-primary-color" v-if="totalPayments"> {{ currencyFormat(totalPayments) }}</h2>
            <div v-else-if="loading" class="row d-flex font-weight-bolder justify-content-center mt-2">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw mt-4"></i>
            </div>
            <span v-if="hasPayments">VALOR TOTAL DAS {{ payments.length }} PARCELAS FUTURAS</span><br>
            <div class="mt-4">
                <small v-if="hasPayments">Nosso prazo máximo para emissão de boletos é de até 48 horas.</small><br>
                <!--
                  Promete envio do boleto por e-mail, que é do fluxo do MEGA.
                  Com ele oculto nenhum boleto é emitido por esta tela, então
                  o aviso sairia falso — volta junto com o botão.
                -->
                <small v-if="hasPayments && (antecipacaoMega || antecipacaoSalesforce)">Importante ficar atento ao e-mail cadastrado, o boleto será encaminhado para
                    ele. </small><br v-if="antecipacaoMega || antecipacaoSalesforce">
                <small v-if="hasPayments">Conforme procedimento bancário padrão, a compensação de boletos está prevista
                    para ocorrer em até 72
                    horas úteis. </small>
            </div>
            <div class="mt-4 mb-2" v-if="showDiscount">
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <h3>{{ currencyFormat(modalAntecipate.discountValue) }}</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <h3 style="color: #0b98de;">{{ currencyFormat(modalAntecipate.discount) }}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6"><small>Valor a pagar</small></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6"><small style="color: #0b98de;">Desconto</small></div>
                </div>
            </div>
            <div v-if="showDiscount" class="mt-4 d-flex flex-wrap justify-content-center">
                <button v-if="antecipacaoMega || antecipacaoSalesforce" type="button" @click="openModal"
                    class="btn custom-btn bg-segment-primary-color text-center justify-content-center"
                    :disabled="loadingButton">Quero antecipar <i v-if="loadingButton"
                        class="fa fa-spinner fa-pulse fa-fw"></i></button>
                <!--
                  Antecipação pela CUB. **Mesmo rótulo do botão acima**, que é
                  o do fluxo do MEGA e está oculto por `antecipacaoMega` — só
                  um dos dois aparece. Os dois ficam lado a lado para que,
                  quando o antigo voltar, dê para comparar os dois caminhos
                  com a mesma seleção de parcelas.

                  Hoje este é um ENSAIO: o backend monta o payload real de
                  `POST /billings/multiple`, registra em log e aborta antes de
                  enviar. Nenhuma cobrança é criada.
                -->
                <!--
                  Sem `bg-segment-primary-color` o rótulo sumia: `.custom-btn`
                  força `color: #fff !important`, e o fundo transparente do
                  `btn-outline-*` deixava texto branco sobre branco.
                -->
                <button v-if="!antecipacaoSalesforce" type="button" @click="antecipateCub" style="margin-left: 8px; background-color: #6c757d;"
                    class="btn custom-btn text-center justify-content-center"
                    :disabled="loadingDryRun">Quero antecipar <i v-if="loadingDryRun"
                        class="fa fa-spinner fa-pulse fa-fw"></i></button>
            </div>
            <div v-if="temSegundaVia" class="mt-3 mx-4 p-3" style="background-color: rgba(255, 152, 0, 0.15); border-radius: 10px;">
                <span class="font-weight-bold" style="color: rgba(180, 100, 0, 1); font-size: 13px;">
                    Você possui uma segunda via em aberto. Selecione-a abaixo para copiar o código ou receber por e-mail.
                </span>
            </div>
            <div v-if="selectedSegundaVia" class="mt-3">
                <div class="mb-2">
                    <h3 class="segment-primary-color">{{ currencyFormat(selectedSegundaVia.valorcorrigido) }}</h3>
                    <small>Parcela {{ selectedSegundaVia.par_in_codigo }} - Vencimento {{ formatDate(selectedSegundaVia.par_dt_vencimento) }}</small>
                </div>
                <div class="d-flex justify-content-center gap-2 flex-wrap">
                    <button v-if="selectedSegundaVia.barcode" type="button" @click="copyBarcode"
                        class="btn custom-btn bg-segment-primary-color">
                        <i class="fas fa-copy me-1"></i> Copiar Código
                    </button>
                    <!-- PIX e PDF só existem quando o boleto foi emitido na CUB -->
                    <button v-if="temPix(selectedSegundaVia)" type="button" @click="copyPix"
                        class="btn custom-btn bg-segment-primary-color">
                        <i class="fas fa-qrcode me-1"></i> Copiar PIX
                    </button>
                    <!--
                      Sem guarda de `pdf_url`: o helper abre a URL da CUB quando
                      existe e cai no `/boleto-ws` quando o boleto é do MEGA.
                    -->
                    <button type="button" @click="verBoleto"
                        class="btn btn-outline-primary">
                        <i class="fas fa-file-pdf me-1"></i> Ver Boleto
                    </button>
                    <button type="button" @click="modalSegundaViaEmail = true"
                        class="btn btn-outline-primary">
                        <i class="fas fa-envelope me-1"></i> Receber por E-mail
                    </button>
                </div>
            </div>
            <div class="mt-4">
                <span v-if="hasPayments" style="font-size: 14px;">Selecione parcelas para antecipar</span>
            </div>
            <div v-if="!loading && !hasPayments" class="mb-4">
                <span class="segment-primary-color font-weight-bolder mb-4" style="font-size: 15px;">SEM PARCELAS
                    FUTURAS</span>
            </div>
        </div>
        <div v-if="hasPayments" class="mt-2 d-flex justify-content-center mb-2 ms-2">
            <table class="table align-items-center mb-0">
                <thead>
                    <tr class="mb-2 ms-2">
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Parcela
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Valor</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Vencimento
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="payment in payments" :key="payment.par_in_codigo">
                        <td>
                            <div class="d-flex px-2 py-1">
                                <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-xs">{{ payment.par_in_codigo }}</h6>
                                    <p class="text-xs text-secondary mb-0">{{ getSituation(payment.situacao_parcela) }}
                                    </p>
                                    <span v-if="isSegundaVia(payment)" class="text-xs font-weight-bold" style="color: #E5A100;">
                                        Segunda via (parcela em atraso)
                                    </span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="text-xs font-weight-bold mb-0">{{ currencyFormat(payment.valorcorrigido)
                            }}</span>
                        </td>
                        <td>
                            <p class="text-xs font-weight-bold mb-0">{{ formatDate(payment.par_dt_vencimento) }}</p>
                        </td>
                        <td>
                            <div v-if="payment.situacao_parcela == 'A_PAGAR'" class="form-check my-auto ms-auto">
                                <input :id="payment.par_in_codigo" class="form-check-input" type="checkbox"
                                    style="width: 30px;height: 30px;"
                                    :disabled="selectedSegundaVia != null"
                                    @change="toggleSelection(payment.par_in_codigo)" />
                            </div>
                            <div v-if="isSegundaVia(payment)" class="form-check my-auto ms-auto">
                                <input :id="'sv_' + payment.par_in_codigo" class="form-check-input" type="checkbox"
                                    style="width: 30px;height: 30px;"
                                    :checked="selectedSegundaVia?.par_in_codigo === payment.par_in_codigo"
                                    :disabled="selectedPayments.length > 0"
                                    @change="selectSegundaVia(payment)" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <Dialog v-model:visible="visible" modal header="Antecipar Parcelas" :style="{ width: '25rem' }">
        <div class="row mb-2">
            <div class="col-12 text-center">
                <h2>{{ currencyFormat(modalAntecipate.totalValue) }}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex justify-content-start">Valor</div>
            <div class="col-6 d-flex justify-content-end">{{ currencyFormat(modalAntecipate.discountValue) }}</div>
        </div>
        <div class="row">
            <div class="col-6 d-flex justify-content-start">Desconto</div>
            <div class="col-6 d-flex justify-content-end">{{ currencyFormat(modalAntecipate.discount) }}</div>
        </div>
        <div v-if="antecipacaoSalesforce && modalAntecipate.percentual !== null" class="row">
            <div class="col-6 d-flex justify-content-start">% de desconto</div>
            <div class="col-6 d-flex justify-content-end">{{ formatPercent(modalAntecipate.percentual) }}</div>
        </div>
        <div v-if="!antecipacaoSalesforce" class="mt-4 row">
            <label>Data de pagamento</label>
            <argon-input type="text" placeholder="" v-model="paymentDate" v-maska="'##/##/####'" />
        </div>
        <!--
          No chamado o vencimento é um campo que abre o calendário ao clicar,
          com a janela já em `:min-date`/`:max-date` (piso D+2, porque quem
          emite é o Financeiro). O backend confere a mesma janela.

          `positionFixed`: o conteúdo do Dialog tem overflow, e o popover
          absoluto ficaria cortado dentro dele.
        -->
        <div v-if="antecipacaoSalesforce" class="row mt-3">
            <label class="col-12 mb-1">Vencimento do boleto</label>
            <div v-if="!janelaVencimentoVazia" class="col-12">
                <VDatePicker :model-value="dataVencimentoEscolhida"
                    :first-day-of-week="0" :min-date="pisoVencimento.toDate()"
                    :max-date="tetoVencimento ? tetoVencimento.toDate() : undefined"
                    :masks="{ input: 'DD/MM/YYYY' }"
                    :popover="{ visibility: 'click', placement: 'bottom-start', positionFixed: true }"
                    @update:model-value="escolherVencimento">
                    <template #default="{ inputValue, inputEvents }">
                        <div class="campo-vencimento">
                            <InputText readonly class="w-100" placeholder="Selecione a data"
                                :value="inputValue" v-on="inputEvents" />
                            <i class="fa fa-calendar campo-vencimento-icone" aria-hidden="true"></i>
                        </div>
                    </template>
                </VDatePicker>
            </div>
            <div class="col-12 text-xs mt-1"
                :class="erroDataVencimento ? 'text-danger' : 'text-secondary'">
                {{ erroDataVencimento || avisoDataVencimento }}
            </div>
        </div>
        <!--
          Os dois campos são do fluxo do MEGA e do chamado. A CUB calcula o
          valor pelas parcelas escolhidas e não recebe endereço de e-mail em
          requisição nenhuma.
        -->
        <div v-if="antecipacaoMega || antecipacaoSalesforce" class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Valor a pagar</label>
            <argon-input type="text" placeholder="" v-model="antecipateValue" v-money="money" />
        </div>
        <div v-if="antecipacaoMega || antecipacaoSalesforce" class="mt-4 col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Enviar boleto para</label>
            <InputText type="text" class="w-100" placeholder="" v-model="userMail" disabled />
        </div>

        <div v-if="antecipacaoSalesforce && newSimulateDiscount" class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton || !!erroDataVencimento" type="button" @click="newSimulate()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Simular antecipação <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
        <div v-if="antecipacaoSalesforce && !newSimulateDiscount && confirmSolicitation" class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton || !!erroDataVencimento || !ultimaSimulacao" type="button" @click="enviarChamadoAntecipacao()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar Solicitação <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>

        <div v-if="antecipacaoMega && newSimulateDiscount" class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton" type="button" @click="newSimulate()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Simular antecipação <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
        <div v-if="antecipacaoMega && !newSimulateDiscount && confirmSolicitation" class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton" type="button" @click="sendAdvance()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar Solicitação <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
    <Dialog v-model:visible="visibleDryRun" modal header="Antecipar parcelas" :style="{ width: '34rem' }">
        <!-- Resumo do que será antecipado -->
        <table class="table table-sm mb-3">
            <thead>
                <tr class="text-xs text-secondary">
                    <th>Parcela</th>
                    <th>Vencimento</th>
                    <th class="text-end">Valor</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="p in parcelasSelecionadas" :key="p.par_in_codigo" class="text-xs">
                    <td>{{ p.par_in_codigo }}</td>
                    <td>{{ formatDate(p.par_dt_vencimento) }}</td>
                    <td class="text-end">{{ currencyFormat(p.valorcorrigido) }}</td>
                </tr>
            </tbody>
        </table>

        <div class="row">
            <div class="col-6">Valor total</div>
            <div class="col-6 text-end">{{ currencyFormat(modalAntecipate.totalValue) }}</div>
        </div>
        <div class="row">
            <div class="col-6">Desconto</div>
            <div class="col-6 text-end" style="color: #0b98de;">{{ currencyFormat(modalAntecipate.discount) }}</div>
        </div>
        <div class="row font-weight-bold mt-1">
            <div class="col-6">Valor a pagar</div>
            <div class="col-6 text-end">{{ currencyFormat(valorAPagar) }}</div>
        </div>
        <!--
          Vencimento do boleto — o `dueDate` de `POST /billings/multiple`.

          Era um input de texto com máscara: o cliente digitava e só descobria
          o limite pela mensagem de erro. Virou calendário (`VCalendar`, o
          mesmo componente de `Schedule/components/Calendar.vue`) com a janela
          permitida já em `:min-date`/`:max-date` — fora dela o dia nem clica.
        -->
        <div class="row mt-3">
            <label class="col-12 text-xs mb-1">Vencimento do boleto</label>
            <div v-if="!janelaVencimentoVazia" class="col-12">
                <VCalendar expanded :first-day-of-week="0" :min-date="pisoVencimento.toDate()"
                    :max-date="tetoVencimento ? tetoVencimento.toDate() : undefined"
                    :attributes="atributosVencimento" :nav-visibility="'click'"
                    @dayclick="selecionarVencimento" />
            </div>
            <div class="col-12 text-xs mt-1"
                :class="erroDataVencimento ? 'text-danger' : 'text-secondary'">
                {{ erroDataVencimento || avisoDataVencimento }}
            </div>
        </div>

        <!--
          TEMPORÁRIO — remover quando a integração estiver validada.
          Mostra o corpo exato de `POST /billings/multiple`. Vem da rota de
          ensaio, que monta o payload e aborta antes de enviar, então abrir
          isto não cria nada.
        -->
        <div class="mt-3 border-top pt-2">
            <a href="#" @click.prevent="mostrarPayload = !mostrarPayload" class="text-xs segment-primary-color">
                <i :class="mostrarPayload ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="me-1"></i>
                Payload que será enviado (temporário)
                <i v-if="loadingDryRun" class="fa fa-spinner fa-pulse fa-fw ms-1"></i>
            </a>

            <div v-if="mostrarPayload" class="mt-2 text-xs">
                <template v-if="dryRunResultado && dryRunResultado.dry_run">
                    <div class="mb-1"><b>{{ dryRunResultado.cub?.method }} {{ dryRunResultado.cub?.url }}</b></div>
                    <pre style="background:#f5f5f5; padding:10px; border-radius:8px; max-height:220px; overflow:auto;">{{ JSON.stringify(dryRunResultado.cub?.payload, null, 2) }}</pre>
                    <div class="mb-1"><b>Travas da emissão</b></div>
                    <pre style="background:#f5f5f5; padding:10px; border-radius:8px;">{{ JSON.stringify(dryRunResultado.cub?.travas, null, 2) }}</pre>
                </template>
                <template v-else-if="dryRunResultado">
                    <div class="p-2" style="background-color: rgba(220, 53, 69, 0.12); border-radius: 8px;">
                        Não foi possível montar o payload:
                        {{ dryRunResultado.result?.DESCRICAO || 'sem detalhe devolvido pelo backend.' }}
                    </div>
                </template>
                <template v-else>
                    <div class="text-secondary">Carregando…</div>
                </template>
            </div>
        </div>

        <!-- Resultado da confirmação -->
        <div v-if="resultadoAntecipacao" class="mt-3 p-2 text-xs"
            :style="resultadoAntecipacao.erro
                ? 'background-color: rgba(220, 53, 69, 0.12); border-radius: 8px;'
                : 'background-color: rgba(40, 167, 69, 0.12); border-radius: 8px;'">
            <div class="font-weight-bold mb-1">
                {{ resultadoAntecipacao.erro ? 'Não foi possível antecipar' : 'Antecipação concluída' }}
            </div>
            <div>{{ resultadoAntecipacao.mensagem }}</div>
            <div v-if="resultadoAntecipacao.linha" class="mt-2">
                <b>Linha digitável</b><br>
                <span style="font-family: monospace; word-break: break-all;">{{ resultadoAntecipacao.linha }}</span>
            </div>
        </div>

        <div class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingConfirmar || !parcelasSelecionadas.length || !!erroDataVencimento" type="button"
                @click="confirmarAntecipacao"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar antecipação <i v-if="loadingConfirmar" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>

    <Dialog v-model:visible="modalSegundaViaEmail" modal header="Receber Segunda Via por E-mail" :style="{ width: '25rem' }">
        <div class="mt-2">
            <label>Enviar boleto para</label>
            <InputText type="text" class="w-100" v-model="userMail" disabled />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingSegundaVia" type="button" @click="sendSegundaViaEmail()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar <i v-if="loadingSegundaVia" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
</template>
<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import moment from 'moment';
import axios from 'axios';
import { useStore } from 'vuex';
import Dialog from 'primevue/dialog';
import ArgonInput from '@/components/ArgonInput.vue';
import InputText from 'primevue/inputtext';
import { showToast } from '@/assets/js/toast.js';
import { VMoney } from 'v-money';
import {
    abrirBoleto,
    copiarLinhaDigitavel,
    copiarPix,
    temPix,
} from '@/helpers/boleto';

const money = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false
};

const previousPaymentDate = ref('');
const previousAntecipateValue = ref('');
const loading = ref(true);
const loadingButton = ref(false);
const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);
const payments = ref([]);
const totalPayments = ref(0);
const selectedPayments = ref([]);
const visible = ref(false);
const newSimulateDiscount = ref(true)
const confirmSolicitation = ref(false)
const showDiscount = ref(false)
const loadingDryRun = ref(false)
const visibleDryRun = ref(false)
const dryRunResultado = ref(null)
const mostrarPayload = ref(false)
const loadingConfirmar = ref(false)
const resultadoAntecipacao = ref(null)
const paymentDate = ref();
const antecipateValue = ref('');
/**
 * Fluxo antigo de antecipação, o que passa pelo SOAP do MEGA
 * (`ObterBoletoAntecipacaoParcelas`).
 *
 * Desligado em 07/10/2026: o fluxo não foi confirmado e pode voltar, então
 * **nada foi apagado** — só fica oculto enquanto isto for `false`.
 *
 * Voltam juntos, porque são do mesmo fluxo e a CUB não os suporta:
 *
 *   - botão "Quero antecipar" do MEGA (o de cima; o de baixo tem o mesmo
 *     rótulo e é o da CUB) e os de "Simular antecipação" / "Confirmar
 *     Solicitação" dentro do diálogo
 *   - campo **Valor a pagar** — a CUB não aceita valor arbitrário: o valor
 *     sai das parcelas escolhidas. O `CreateBillingMultipleRequestDto` não
 *     tem campo de valor, só `debtRelief` e `incentiveDiscount`, que são
 *     descontos
 *   - campo **Enviar boleto para** — a CUB só tem `sendNotification`, um
 *     indicador; a notificação vai para o contato cadastrado nela. Não há
 *     campo de e-mail em requisição nenhuma da API
 *
 * O equivalente no app é `AppConstants.ANTECIPACAO_MEGA_HABILITADA`.
 */
const antecipacaoMega = false;

/**
 * Antecipação por chamado no Salesforce.
 *
 * Mesmo caminho do fluxo do MEGA — selecionar, ver o desconto, escolher o
 * valor a pagar —, mas "Confirmar Solicitação" abre um caso "SOLICITAÇÃO DE
 * BOLETO DE ANTECIPAÇÃO" para o Financeiro em vez de efetivar no MEGA. O
 * desconto vem do MEGA por `/simulate-antecipation-mega`, que nunca efetiva.
 *
 * Tem precedência: com `true`, o botão da CUB some. O equivalente no app é
 * `AppConstants.ANTECIPACAO_SALESFORCE_HABILITADA`.
 */
const antecipacaoSalesforce = true;

// Corpo da última simulação que deu certo. O chamado é aberto com ele, para
// o caso levar exatamente os números que a tela mostrou.
const ultimaSimulacao = ref(null);

const modalAntecipate = ref({
    totalValue: null,
    discountValue: null,
    discount: null,
    percentual: null,
    parcels: null,
    // Teto do vencimento devolvido pela CUB na simulacao
    // (`maximumStandaloneBillingDueDate`). Nulo quando a simulacao nao
    // passou pela CUB.
    vencimentoMaximo: null
});

/**
 * Janela em que o vencimento do boleto de antecipação pode cair.
 *
 *   piso = D+1, ajustado para dia útil
 *   teto = o vencimento da **parcela selecionada mais próxima**, limitado
 *          também pelo `maximumStandaloneBillingDueDate` da CUB
 *
 * O teto pela parcela mais próxima é regra de negócio da Brasal: não faz
 * sentido antecipar uma parcela para depois de ela mesma vencer — aí já não
 * é antecipação, e o desconto que a CUB calcula perde a base.
 *
 * ATENÇÃO — o **piso** continua sem confirmação da CUB, que informa só o
 * teto. Ver PERGUNTAS-CUB.md (pergunta 9). Nada disso é validado no backend:
 * `ContractWsController::antecipateCub` só exige `antecipate_date` presente,
 * então a regra vive aqui e no app, não no servidor.
 */
// No chamado quem emite é o Financeiro, que precisa de prazo: D+2, como no
// fluxo antigo do MEGA. O backend aplica o mesmo piso.
const DIAS_MINIMOS_VENCIMENTO = antecipacaoSalesforce ? 2 : 1;

const dataMinimaVencimento = () => {
    const data = moment().add(DIAS_MINIMOS_VENCIMENTO, 'days');
    if (data.day() === 6) { data.add(2, 'days'); }
    if (data.day() === 0) { data.add(1, 'days'); }
    return data;
};

// Recalcula a cada mudança de `paymentDate`/seleção, o que basta: a tela não
// fica aberta atravessando a meia-noite em uso normal.
const pisoVencimento = computed(() => dataMinimaVencimento());

// Teto da CUB (`maximumStandaloneBillingDueDate`), capturado na simulação.
const tetoCub = computed(() => {
    const teto = modalAntecipate.value.vencimentoMaximo;
    if (!teto) { return null; }
    const data = moment(teto, 'YYYY-MM-DD', true);
    return data.isValid() ? data : null;
});

// Vencimento da parcela selecionada mais próxima. `par_dt_vencimento` chega
// como 'YYYY-MM-DD HH:mm:ss' (NLS_DATE_FORMAT do oci8).
//
// Lê `payments`/`selectedPayments` em vez de `parcelasSelecionadas`, que é
// declarada mais abaixo: o `watch` no fim deste bloco avalia o getter uma vez
// no setup e cairia no TDZ da const ainda não inicializada.
const tetoParcela = computed(() => {
    const datas = payments.value
        .filter(p => selectedPayments.value.includes(p.par_in_codigo))
        .map(p => moment(p.par_dt_vencimento))
        .filter(d => d.isValid());
    return datas.length ? moment.min(datas) : null;
});

// O teto efetivo é o menor dos dois.
const tetoVencimento = computed(() => {
    const candidatos = [tetoParcela.value, tetoCub.value].filter(Boolean);
    return candidatos.length ? moment.min(candidatos) : null;
});

// Acontece quando a parcela mais próxima vence hoje ou amanhã: não sobra dia
// nenhum entre o piso e o teto. Nesse caso não há antecipação possível.
const janelaVencimentoVazia = computed(() =>
    !!tetoVencimento.value && tetoVencimento.value.isBefore(pisoVencimento.value, 'day'));

const erroDataVencimento = computed(() => {
    if (janelaVencimentoVazia.value) {
        return 'A parcela mais próxima vence em '
            + tetoVencimento.value.format('DD/MM/YYYY')
            + ' — cedo demais para emitir um boleto de antecipação.';
    }

    const valor = (paymentDate.value || '').trim();
    if (valor.length < 10) { return 'Escolha o vencimento no calendário.'; }

    const data = moment(valor, 'DD/MM/YYYY', true);
    if (!data.isValid()) { return 'Data inválida.'; }

    if (data.isBefore(pisoVencimento.value, 'day')) {
        return 'O vencimento precisa ser a partir de '
            + pisoVencimento.value.format('DD/MM/YYYY') + '.';
    }

    if (tetoVencimento.value && data.isAfter(tetoVencimento.value, 'day')) {
        return 'O vencimento não pode passar de '
            + tetoVencimento.value.format('DD/MM/YYYY') + '.';
    }

    return null;
});

const avisoDataVencimento = computed(() => {
    const minima = pisoVencimento.value.format('DD/MM/YYYY');
    if (!tetoVencimento.value) { return 'A partir de ' + minima + '.'; }

    const limite = tetoVencimento.value.format('DD/MM/YYYY');
    // Diz *por que* o limite é aquele — senão parece arbitrário para o cliente.
    const motivo = (tetoCub.value && tetoCub.value.isSame(tetoVencimento.value, 'day')
        && !(tetoParcela.value && tetoParcela.value.isSame(tetoVencimento.value, 'day')))
        ? ' (limite da CUB)'
        : ' (vencimento da parcela mais próxima)';

    return 'De ' + minima + ' até ' + limite + motivo + '.';
});

// Destaca no calendário o dia escolhido.
const atributosVencimento = computed(() => {
    const data = moment(paymentDate.value, 'DD/MM/YYYY', true);
    return data.isValid()
        ? [{ key: 'escolhido', highlight: true, dates: data.toDate() }]
        : [];
});

// Ponte entre o `paymentDate` ('DD/MM/YYYY') e o `VDatePicker` (Date).
const dataVencimentoEscolhida = computed(() => {
    const data = moment(paymentDate.value, 'DD/MM/YYYY', true);
    return data.isValid() ? data.toDate() : null;
});

const escolherVencimento = (data) => {
    paymentDate.value = data ? moment(data).format('DD/MM/YYYY') : '';
};

const selecionarVencimento = (day) => {
    if (day.isDisabled) { return; }
    paymentDate.value = moment(day.id, 'YYYY-MM-DD', true).format('DD/MM/YYYY');
};

/**
 * Mantém a data dentro da janela quando a seleção de parcelas muda.
 *
 * Sem isto: o cliente escolhe 20/12, depois desmarca a parcela de janeiro e
 * sobra a de 05/12 — a data continuaria 20/12, agora acima do teto, e a
 * simulação seguiria com ela.
 */
watch(tetoVencimento, (teto) => {
    if (!teto || janelaVencimentoVazia.value) { return; }
    const atual = moment(paymentDate.value, 'DD/MM/YYYY', true);
    if (!atual.isValid() || atual.isAfter(teto, 'day')) {
        paymentDate.value = teto.format('DD/MM/YYYY');
    } else if (atual.isBefore(pisoVencimento.value, 'day')) {
        paymentDate.value = pisoVencimento.value.format('DD/MM/YYYY');
    }
});

const userMail = store.getters.getCurrentUser ? store.getters.getCurrentUser.email : null;

const hasPayments = computed(() => payments.value && payments.value.length > 0);
const selectedSegundaVia = ref(null);
const modalSegundaViaEmail = ref(false);
const loadingSegundaVia = ref(false);
// Só a 2ª via de parcela **em atraso** é selecionável aqui.
//
// Chegou a valer para qualquer `EM_ABERTO`, para alcançar a parcela a vencer
// com cobrança já emitida. Revertido: na aba Próximas essa parcela não deve
// ter checkbox — não há o que antecipar num boleto que já existe. Quem a
// atende é o card "Parcelas em aberto" (`OpenParcels.vue`), que já oferece
// código, PIX, PDF e e-mail. O app segue a mesma regra, em `ParcelItem.js`.
const isSegundaVia = (payment) => payment.situacao_parcela === 'EM_ABERTO' && payment.par_atrasada === 'SIM';

const temSegundaVia = computed(() => payments.value.some(isSegundaVia));

const selectSegundaVia = (payment) => {
    if (selectedSegundaVia.value?.par_in_codigo === payment.par_in_codigo) {
        selectedSegundaVia.value = null;
    } else {
        selectedSegundaVia.value = payment;
    }
};

// Copia o valor cru, sem pontuação: é o que o cliente cola no app do banco.
const copyBarcode = async () => {
    if (await copiarLinhaDigitavel(selectedSegundaVia.value)) {
        showToast('Código copiado para a área de transferência.', 'success');
    } else {
        showToast('Não foi possível copiar o código.', 'error');
    }
};


const copyPix = async () => {
    if (await copiarPix(selectedSegundaVia.value)) {
        showToast('PIX copiado para a área de transferência.', 'success');
    } else {
        showToast('Não foi possível copiar o PIX.', 'error');
    }
};

// `pdf_url` já veio com a parcela, então abre sem request.
const verBoleto = async () => {
    const resultado = await abrirBoleto(selectedSegundaVia.value, {
        contrato: contractData.value.contrato_id,
        agente: store.getters.getCurrentUser ? store.getters.getCurrentUser.id : null,
    });

    if (!resultado.ok) {
        showToast(resultado.erro, 'error');
    }
};

const sendSegundaViaEmail = async () => {
    try {
        loadingSegundaVia.value = true;
        // Reenvio do boleto que já existe. Antes ia para `/duplicate`, que
        // **emitia** uma segunda via a cada clique.
        const data = {
            parcel: selectedSegundaVia.value.par_in_codigo,
            email: userMail,
        };
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/boleto-email`, data);
        if (response.data?.result?.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
        } else {
            showToast('Boleto enviado para o e-mail cadastrado.', 'success');
            modalSegundaViaEmail.value = false;
        }
    } catch (error) {
        showToast(error?.response?.data?.result?.DESCRICAO || 'Erro ao enviar boleto por e-mail.', 'error');
    } finally {
        loadingSegundaVia.value = false;
    }
};

const isInitialLoad = ref(true);

onMounted(async () => {
    getPayments();
    // getNextPayments();
    // getOpenPayments();
    // Piso da janela (D+1 em dia útil). O `watch(tetoVencimento)` desce isto
    // para o teto se a parcela mais próxima vencer antes.
    paymentDate.value = dataMinimaVencimento().format('DD/MM/YYYY');
});

// const getNextPayments = async () => {
//     try {
//         const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=A_PAGAR`);
//         payments.value = response.data;
//         sumTotalNextPayments();
//         loading.value = false;
//     } catch (error) {
//         console.error(error);
//     }
// };

// const getOpenPayments = async () => {
//     try {
//         const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ABERTO`);
//         payments.value = response.data;
//         sumTotalNextPayments();
//         loading.value = false;
//     } catch (error) {
//         console.error(error);
//     }
// };

const getPayments = async () => {
    try {
        // Executa as duas requisições em paralelo
        const [openPaymentsResponse, nextPaymentsResponse] = await Promise.all([
            axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ABERTO`),
            axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=A_PAGAR`),
        ]);

        // Mescla os dados das duas respostas
        payments.value = [...openPaymentsResponse.data, ...nextPaymentsResponse.data];

        // Calcula o total
        sumTotalNextPayments();
        loading.value = false;
    } catch (error) {
        console.error(error);
    }
}

const getSituation = (situation) => {
    switch (situation) {
        case 'EM_ABERTO':
            return 'VIGENTE'
        case 'A_PAGAR':
            return 'FUTURA'
    }
}

const newValues = () => {
    newSimulateDiscount.value = true;
    confirmSolicitation.value = false;
}

const newSimulate = () => {
    const data = {
        parcel: modalAntecipate.value.parcels,
        send_mail: false,
        email: 'simulate-test@simulate-test.com.br',
        notificacao: false,
        effect: false,
        antecipate_date: paymentDate.value,
        valor_pagar: antecipateValue.value
    }
    console.log(data)
    simulateDiscount(data)
}

const toggleSelection = (paymentId) => {
    const index = selectedPayments.value.indexOf(paymentId);
    if (index === -1) {
        selectedPayments.value.push(paymentId);
    } else {
        selectedPayments.value.splice(index, 1);
    }

    if (selectedPayments.value.length === 0) {
        showDiscount.value = false;
        return;
    }

    simulateDiscount(corpoSimulacao())
};

/**
 * Corpo da simulacao (`effect: false`, somente leitura).
 *
 * A data vai aqui tambem, e nao so no payload da emissao: o desconto de
 * antecipacao depende de quando se paga. Antes a selecao simulava com
 * D+1 enquanto a tela exibia outra data.
 */
const corpoSimulacao = () => ({
    parcel: selectedPayments.value.join(','),
    send_mail: false,
    email: 'simulate-test@simulate-test.com.br',
    notificacao: false,
    effect: false,
    antecipate_date: paymentDate.value || dataMinimaVencimento().format('DD/MM/YYYY'),
});

// Ensaio: manda a mesma seleção para a rota de dry-run e mostra o payload que
// iria para a CUB. O backend registra no log e aborta antes de enviar — não há
// caminho daqui que crie cobrança.
// Parcelas do resumo: as marcadas na lista, com os dados que já estão em mão.
const parcelasSelecionadas = computed(() =>
    payments.value.filter(p => selectedPayments.value.includes(p.par_in_codigo)));

const valorAPagar = computed(() =>
    (Number(modalAntecipate.value.totalValue) || 0) - (Number(modalAntecipate.value.discount) || 0));

/**
 * Abre o resumo da antecipação.
 *
 * O payload do accordion vem da rota de **ensaio**, que monta o corpo real e
 * aborta antes de enviar — abrir o resumo não cria nada. Quem emite é só o
 * "Confirmar antecipação", em `confirmarAntecipacao()`.
 */
const carregarPayloadEnsaio = async () => {
    const data = {
        parcel: selectedPayments.value.join(','),
        antecipate_date: paymentDate.value || dataMinimaVencimento().format('DD/MM/YYYY'),
    }

    try {
        loadingDryRun.value = true
        const response = await axios.post(
            `/contract-ws/${contractData.value.contrato_id}/antecipate-cub-dry-run`, data);

        dryRunResultado.value = response.data
    } catch (error) {
        dryRunResultado.value = error?.response?.data || {
            result: { DESCRICAO: 'Não foi possível montar o payload.' },
        };
        console.error(error);
    } finally {
        loadingDryRun.value = false
    }
}

const antecipateCub = async () => {
    // O resumo abre na hora; o payload chega depois, para o accordion.
    dryRunResultado.value = null
    resultadoAntecipacao.value = null
    mostrarPayload.value = false
    visibleDryRun.value = true

    await carregarPayloadEnsaio()
}

// Trocar a data envelhece as duas coisas da tela: o desconto, que depende de
// quando se paga, e o payload do accordion, que leva a data no `dueDate`.
// Refaz os dois para que o resumo seja o que o confirmar vai enviar.
watch(paymentDate, () => {
    if (!visibleDryRun.value || erroDataVencimento.value) { return; }

    simulateDiscount(corpoSimulacao());
    carregarPayloadEnsaio();
});

/**
 * Emite a antecipação na CUB — `POST /billings/multiple`.
 *
 * Rota própria (`/antecipate-cub`), e não a `antecipate-bill-installments-parcels`:
 * aquela cai no SOAP do MEGA quando `CUB_EMISSION_ENABLED` está `false`, e um
 * botão que diz "antecipar pela CUB" não pode emitir boleto do MEGA por engano.
 * Com a emissão desligada esta recusa, sem criar nada em lugar nenhum.
 */
const confirmarAntecipacao = async () => {
    const data = {
        parcel: selectedPayments.value.join(','),
        antecipate_date: paymentDate.value || dataMinimaVencimento().format('DD/MM/YYYY'),
    }

    try {
        loadingConfirmar.value = true
        resultadoAntecipacao.value = null

        const response = await axios.post(
            `/contract-ws/${contractData.value.contrato_id}/antecipate-cub`, data);

        const r = response.data?.result || {}

        if (r.ERRO) {
            resultadoAntecipacao.value = { erro: true, mensagem: r.DESCRICAO || 'Falha na antecipação.' }
            return
        }

        resultadoAntecipacao.value = {
            erro: false,
            mensagem: 'Cobrança criada na CUB.',
            linha: r.LINHA_DIGITAVEL || null,
        }
        showToast('Antecipação realizada.', 'success')
    } catch (error) {
        resultadoAntecipacao.value = {
            erro: true,
            mensagem: error?.response?.data?.result?.DESCRICAO
                || error?.response?.data?.message
                || 'Não foi possível concluir a antecipação.',
        }
        console.error(error);
    } finally {
        loadingConfirmar.value = false
    }
}

const sendAdvance = async () => {
    const data = {
        parcel: modalAntecipate.value.parcels,
        send_mail: false,
        email: userMail,
        notificacao: false,
        effect: true,
        antecipate_date: paymentDate.value,
        valor_pagar: antecipateValue.value
    }
    console.log(data)
    try {
        loadingButton.value = true
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/antecipate-bill-installments-parcels`, data);
        if (response.data.result.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
        } else {
            showToast('Solicitação de adiantamento de parcela enviada com sucesso.', 'success');
            visible.value = false
        }
    } catch (error) {
        showToast('Não foi possivel complatar a solicitação', 'error');
        console.error(error);
    } finally {
        loadingButton.value = false
    }
}

/**
 * Antecipação por chamado: abre o caso no Salesforce com a última simulação.
 *
 * O backend refaz a simulação no MEGA e escreve no caso os valores dela, não
 * os da tela — por isso manda só parcelas, vencimento e valor.
 */
const enviarChamadoAntecipacao = async () => {
    const simulacao = ultimaSimulacao.value
    if (!simulacao) { return }

    const data = {
        contract_id: contractData.value.contrato_id,
        parcel: simulacao.parcel,
        antecipate_date: simulacao.antecipate_date,
        valor_pagar: simulacao.valor_pagar,
        email: userMail,
    }

    try {
        loadingButton.value = true
        const response = await axios.post('/contact/requestAdvancePlots', data);
        if (response.data?.result?.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
            return
        }
        showToast('Solicitação enviada ao Financeiro. O boleto será emitido em até 48 horas e enviado para o seu e-mail.', 'success');
        visible.value = false
    } catch (error) {
        showToast(error?.response?.data?.result?.DESCRICAO
            || error?.response?.data?.message
            || 'Não foi possível enviar a solicitação.', 'error');
        console.error(error);
    } finally {
        loadingButton.value = false
    }
}

const simulateDiscount = async (data) => {
    // No chamado o desconto vem do MEGA por rota que nunca efetiva.
    const url = antecipacaoSalesforce
        ? `/contract-ws/${contractData.value.contrato_id}/simulate-antecipation-mega`
        : `/contract-ws/${contractData.value.contrato_id}/antecipate-bill-installments-parcels`
    const corpo = antecipacaoSalesforce
        ? { parcel: data.parcel, antecipate_date: data.antecipate_date, valor_pagar: data.valor_pagar }
        : data

    try {
        loadingButton.value = true
        ultimaSimulacao.value = null
        const response = await axios.post(url, corpo);

        if (response.data.result.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
        } else {
            ultimaSimulacao.value = corpo
            modalAntecipate.value.totalValue = response.data.result.VALOR_TOTAL
            // No chamado já no formato do `v-money` ("1.234,56"): com o "R$ "
            // a máscara reescrevia o campo logo depois, o `watch` lia isso como
            // edição do cliente e escondia o "Confirmar Solicitação".
            antecipateValue.value = antecipacaoSalesforce
                ? Number(response.data.result.VALOR_TOTAL || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : currencyFormat(response.data.result.VALOR_TOTAL)
            previousAntecipateValue.value = antecipateValue.value
            modalAntecipate.value.discountValue = response.data.result.VALOR_ANTECIPADO
            modalAntecipate.value.discount = response.data.result.VALOR_DESCONTO
            modalAntecipate.value.percentual = response.data.result.PERCENTUAL_DESCONTO ?? null
            modalAntecipate.value.parcels = data.parcel
            // Teto do vencimento, quando a simulacao veio da CUB.
            modalAntecipate.value.vencimentoMaximo = response.data.result.VENCIMENTO_MAXIMO || null
            isInitialLoad.value = true;
            newSimulateDiscount.value = false;
            confirmSolicitation.value = true;
        }
    } catch (error) {
        // A rota do chamado responde 422 quando a parcela ou a data não
        // servem; sem o toast a tela só parava de atualizar.
        if (antecipacaoSalesforce) {
            showToast(error?.response?.data?.result?.DESCRICAO || 'Não foi possível calcular o desconto.', 'error');
        }
        console.error(error);
    } finally {
        loadingButton.value = false
        if (selectedPayments.value.length > 0) {
            newSimulateDiscount.value = false;
            confirmSolicitation.value = true;
            showDiscount.value = true;
        } else {
            showDiscount.value = false;
        }
    }
}

const openModal = () => {
    isInitialLoad.value = true;
    visible.value = true
}

const formatPercent = (value) =>
    Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';

const currencyFormat = (value, currency = false) => {
    const options = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedValue = new Intl.NumberFormat('pt-BR', options).format(value);

    if (currency) {
        return `${formattedValue}`;
    }

    return formattedValue;
};

// `isBusinessDay` e `getNextBusinessDay` saíram daqui: as três chamadas que os
// usavam passaram a usar `dataMinimaVencimento`, que aplica o piso D+1. Não
// eram do fluxo do MEGA — eram utilitários de data, e o antigo tinha um
// defeito: começando num dia útil, devolvia o próprio dia.
const sumTotalNextPayments = () => {
    totalPayments.value = payments.value.reduce((acc, payment) => acc + parseFloat(payment.valorcorrigido), 0);
};

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};

// Observadores para detectar mudanças nos valores
watch(paymentDate, (newValue) => {
    if (!isInitialLoad.value && newValue !== previousPaymentDate.value) {
        newValues();
        previousPaymentDate.value = newValue;
    }
    isInitialLoad.value = false; // Após o primeiro carregamento, atualiza a flag
});

watch(antecipateValue, (newValue) => {
    if (!isInitialLoad.value && newValue !== previousAntecipateValue.value) {
        newValues();
        previousAntecipateValue.value = newValue;
    }
    isInitialLoad.value = false; // Após o primeiro carregamento, atualiza a flag
});

</script>
<style>
.bg-color {
    background-color: #ededed !important;
}

.campo-vencimento {
    position: relative;
}

.campo-vencimento input {
    cursor: pointer;
    padding-right: 2.5rem;
    background-color: #fff;
}

.campo-vencimento-icone {
    position: absolute;
    right: 0.9rem;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    pointer-events: none;
}
</style>
